import { render } from "./UserInfoSection.vue?vue&type=template&id=3abcc382"
import script from "./UserInfoSection.vue?vue&type=script&lang=js"
export * from "./UserInfoSection.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__